/** Coach Tools `createdReason` for CCMS band INIT_CD `RI`. */
export const REINSTATEMENT_CREATED_REASON = "re_instatement"

export const hasReinstatementBand = bands =>
  (bands ?? []).some(
    band => band?.createdReason === REINSTATEMENT_CREATED_REASON,
  )
